type Term = {
  anchor: string;
  content: string;
};

export function addLinkData(links?: Term[], text?: string) {
  return links?.reduce(
    (acc, { anchor, content }) =>
      acc?.replace(anchor, `<a data-content="${content}" data-anchor="${anchor}" href="#">${anchor}</a>`),
    text
  );
}
